import styled from '@emotion/styled'
import Card from '../../../../components/common/Card'
import Text from '../../../../components/common/Text'
import { FONT_BLACK, FONT_LIGHT_GRAY } from '../../../../constant/colors'
import { EClaimList, EClaimListItem } from '../../../../services/e-claim/e-claim-types'
import { numberWithCommas } from '../../../../utils/helper'

const Layout = styled.div`
  > * {
    margin-top: 24px;
  }
  text-align: start;
`

const LayoutCard = styled(Card)`
  background-color: WHITE;
  border-radius: 8px;
  margin-bottom: 24px;
  margin-top: 0px;
  padding: 32px;
  /* border: solid 1px #dee2e6; */
`

export type WellBeingWalfareProps = {
  eClaimList?: EClaimList
}

const WellBeingWelfare = (props: WellBeingWalfareProps) => {
  const { eClaimList } = props

  const layoutECliam = (item: EClaimListItem, index: number) => {
    return (
      <div key={`${index}-${item.claimId}`} style={{ marginTop: '16px' }}>
        <Text size={18} type="Bold">
          {item.claimName}
        </Text>
        <Text size={18} color={FONT_LIGHT_GRAY}>
          <li style={{ color: FONT_LIGHT_GRAY }}>
            {numberWithCommas(item.availableAmount || 0)} คะแนน
          </li>
        </Text>
      </div>
    )
  }
  return (
    <Layout>
      <LayoutCard>
        <Text size={28} type="Bold" color={FONT_BLACK}>
          สวัสดิการที่เลือก
        </Text>{' '}
        {eClaimList?.map(layoutECliam)}
      </LayoutCard>
    </Layout>
  )
}

export default WellBeingWelfare
